import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { ICalculateLoanParamsResponse } from "../../../models/loanNew.Model";

const PriceInfo = (calculateLoanParams: ICalculateLoanParamsResponse) => {
  return (
    <Grid
      container
      direction="column"
      sx={{
        py: 3,
        px: 4,
        background: "#F5F6FA",
        border: "1px solid #DAE0E4",
        borderRadius: "5px",
        direction: "rtl",
      }}
    >
      {/* Row 1 */}
      <Grid container alignItems="center" sx={{ p: 3 }}>
        <Grid item xs={6}>
          <Typography>اعتبار خرید مشتری:</Typography>
        </Grid>
        <Grid xs={6} sx={{ textAlign: "left" }}>
          <Typography color="green" sx={{ fontWeight: "bold" }}>
            {calculateLoanParams?.creditAmount?.toLocaleString()} ریال
          </Typography>
        </Grid>
      </Grid>
      <Divider />

      {/* Row 2 */}
      <Grid container alignItems="center" sx={{ p: 3 }}>
        <Grid item xs={6}>
          <Typography>مبلغ هر قسط:</Typography>
        </Grid>
        <Grid xs={6} sx={{ textAlign: "left" }}>
          <Typography color="green" sx={{ fontWeight: "bold" }}>
            {calculateLoanParams?.installmentAmount?.toLocaleString()} ریال
          </Typography>
        </Grid>
      </Grid>
      <Divider />

      {/* Row 3 */}
      <Grid container alignItems="center" sx={{ p: 3 }}>
        <Grid item xs={6}>
          <Typography>هزینه خدمات دیجیتال پذیرنده:</Typography>
        </Grid>
        <Grid xs={6} sx={{ textAlign: "left" }}>
          <Typography color="orange" sx={{ fontWeight: "bold" }}>
            {calculateLoanParams?.supplierFeeAmount?.toLocaleString()} ریال
          </Typography>
        </Grid>
      </Grid>
      <Divider />

      {/* Row 4 */}
      <Grid container alignItems="center" sx={{ p: 3 }}>
        <Grid item xs={6}>
          <Typography>هزینه خدمات دیجیتال مشتری:</Typography>
        </Grid>
        <Grid xs={6} sx={{ textAlign: "left" }}>
          <Typography color="orange" sx={{ fontWeight: "bold" }}>
            {calculateLoanParams?.feeAmount?.toLocaleString()} ریال
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default PriceInfo;
